module.exports = "./3e1af3ef546b9e6ecef9f3ba197bf7d2.ttf";